var map = {
	"./box.png": 62653,
	"./dropbox.png": 78884,
	"./google_workspace.svg": 37759,
	"./icons-dark/IDrive logo.png": 57690,
	"./icons-dark/google-workspace.png": 18885,
	"./icons-dark/google-workspace.svg": 47339,
	"./icons-dark/logo-color.svg": 28181,
	"./icons-disabled/icons/activity-logs.svg": 54236,
	"./icons-disabled/icons/admin.svg": 57712,
	"./icons-disabled/icons/backup-now.svg": 53462,
	"./icons-disabled/icons/box-rounded-gray.svg": 20522,
	"./icons-disabled/icons/calender-icon.svg": 64001,
	"./icons-disabled/icons/close-icon.svg": 36801,
	"./icons-disabled/icons/delete-icon.svg": 74940,
	"./icons-disabled/icons/download.svg": 76887,
	"./icons-disabled/icons/dropbox-rounded-gray.svg": 96549,
	"./icons-disabled/icons/edit.svg": 12479,
	"./icons-disabled/icons/googleworkspace-logo-rounded-gray.svg": 35185,
	"./icons-disabled/icons/microsoft-rounded-gray.svg": 27275,
	"./icons-disabled/icons/overview.svg": 60850,
	"./icons-disabled/icons/recovery-menu.svg": 68542,
	"./icons-disabled/icons/recovery.svg": 25006,
	"./icons-disabled/icons/refresh.svg": 71168,
	"./icons-disabled/icons/responsive-restore-icon.svg": 6742,
	"./icons-disabled/icons/responsive-search-icon.svg": 60652,
	"./icons-disabled/icons/responsive-user-icon.svg": 68695,
	"./icons-disabled/icons/search.svg": 25991,
	"./icons-disabled/icons/seat-management.svg": 69776,
	"./icons-disabled/icons/users.svg": 44101,
	"./icons/Restore-icon.svg": 80197,
	"./icons/activity-logs.svg": 82546,
	"./icons/admin-red.svg": 5172,
	"./icons/admin.svg": 16462,
	"./icons/administrators-color.svg": 785,
	"./icons/administrators.svg": 61315,
	"./icons/arrow-caret-down.svg": 97659,
	"./icons/arrow-caret-right.svg": 99331,
	"./icons/arrow-down.svg": 95321,
	"./icons/arrow-up.svg": 26742,
	"./icons/arrow_01.svg": 74262,
	"./icons/arrow_02.svg": 87221,
	"./icons/arrowscroll-hover.svg": 21722,
	"./icons/arrowscroll.svg": 70035,
	"./icons/avatar.svg": 6822,
	"./icons/backup-color.svg": 12569,
	"./icons/backup-now.svg": 45580,
	"./icons/backup.svg": 46475,
	"./icons/box-rounded.svg": 45240,
	"./icons/business_backup.svg": 84184,
	"./icons/business_backup_box.svg": 59374,
	"./icons/business_backup_dropbox.svg": 34303,
	"./icons/calendar-table.svg": 50936,
	"./icons/calendar.svg": 37179,
	"./icons/calender-icon.svg": 6979,
	"./icons/cancel-icon.svg": 67427,
	"./icons/caret-down.svg": 77959,
	"./icons/chat.svg": 82263,
	"./icons/close-icon-dark.svg": 62588,
	"./icons/close-icon.svg": 38439,
	"./icons/contact-table.svg": 15980,
	"./icons/contacts.svg": 38766,
	"./icons/delete-bin-color.svg": 65494,
	"./icons/delete-bin.svg": 90964,
	"./icons/delete-icon.svg": 50450,
	"./icons/down-arrow-white.svg": 89213,
	"./icons/down-arrow.svg": 72569,
	"./icons/download-color.svg": 90571,
	"./icons/download-lightgray.svg": 85099,
	"./icons/download.svg": 89413,
	"./icons/drives.svg": 5338,
	"./icons/dropbox-rounded.svg": 36213,
	"./icons/dropdown.svg": 87630,
	"./icons/edit-color.svg": 86451,
	"./icons/edit.svg": 29453,
	"./icons/error.svg": 26889,
	"./icons/exchange-onselect.svg": 72472,
	"./icons/exchange.svg": 43494,
	"./icons/export-color.svg": 38209,
	"./icons/export.svg": 74707,
	"./icons/exports-color.svg": 40780,
	"./icons/exports.svg": 35930,
	"./icons/fail.svg": 48365,
	"./icons/failuer-icon.svg": 46199,
	"./icons/folder shortcut.svg": 10993,
	"./icons/folder.svg": 85973,
	"./icons/googleworkspace-logo-rounded.svg": 63617,
	"./icons/help icon.svg": 67611,
	"./icons/info-lighten.svg": 24411,
	"./icons/info-white.svg": 409,
	"./icons/info.svg": 77029,
	"./icons/logout.svg": 77487,
	"./icons/mail.svg": 14444,
	"./icons/marketplace-icon.svg": 96492,
	"./icons/microsoft-rounded.svg": 61527,
	"./icons/na.svg": 64926,
	"./icons/no-results-img.jpeg": 91992,
	"./icons/onedrive-onselect.svg": 57025,
	"./icons/onedrive.svg": 86385,
	"./icons/overview-color.svg": 89918,
	"./icons/overview-shared-mailboxes.svg": 66633,
	"./icons/overview-sites.svg": 83387,
	"./icons/overview-teams.svg": 82265,
	"./icons/overview-total-seats-for-backup-365.svg": 27146,
	"./icons/overview-total-seats-for-backup-google.svg": 99235,
	"./icons/overview-user.svg": 85376,
	"./icons/overview.svg": 36476,
	"./icons/pending-icon.svg": 33880,
	"./icons/personal_backup.svg": 40982,
	"./icons/personal_backup_box.svg": 89568,
	"./icons/personal_backup_dropbox.svg": 31505,
	"./icons/plus-icon.svg": 51689,
	"./icons/protected-data.svg": 28862,
	"./icons/question-mark.svg": 56173,
	"./icons/recovery-color.svg": 24522,
	"./icons/recovery-menu.svg": 42704,
	"./icons/recovery.svg": 28488,
	"./icons/recurring_calendar.svg": 16983,
	"./icons/refresh.svg": 8674,
	"./icons/responsive-restore-icon.svg": 66684,
	"./icons/responsive-search-icon.svg": 58770,
	"./icons/responsive-user-icon.svg": 37569,
	"./icons/restore-color.svg": 68871,
	"./icons/restore.svg": 59345,
	"./icons/restores-color.svg": 34082,
	"./icons/restores.svg": 6496,
	"./icons/right-arrow.svg": 87617,
	"./icons/search-.svg": 95454,
	"./icons/search-color.svg": 54447,
	"./icons/search.svg": 41177,
	"./icons/seat-management-color.svg": 16532,
	"./icons/seat-management.svg": 30210,
	"./icons/shared-drives-icon.svg": 15710,
	"./icons/shared-drives.svg": 62684,
	"./icons/shared-folders.svg": 97302,
	"./icons/sharepoint-onselect.svg": 17554,
	"./icons/sharepoint.svg": 89868,
	"./icons/snapshort-icon.svg": 87781,
	"./icons/sort-icon.svg": 13981,
	"./icons/success-icon.svg": 88452,
	"./icons/success.svg": 56858,
	"./icons/sync-icon.svg": 34246,
	"./icons/teams-onselect.svg": 70969,
	"./icons/teams.svg": 85753,
	"./icons/theme_dark.svg": 34155,
	"./icons/theme_light.svg": 18657,
	"./icons/tick-error-icon.svg": 78591,
	"./icons/tick-icon.svg": 74016,
	"./icons/tick.svg": 20374,
	"./icons/up-arrow-white.svg": 45826,
	"./icons/up-arrow.svg": 6918,
	"./icons/user.svg": 15328,
	"./icons/users-1.svg": 33077,
	"./icons/users-color.svg": 62705,
	"./icons/users-green.svg": 60389,
	"./icons/users.svg": 37571,
	"./images/Gsuite-sprite-image-mail.svg": 17794,
	"./images/dropbox-animation-images.svg": 58295,
	"./images/google-disabled.png": 17005,
	"./images/google.png": 19098,
	"./images/idrive-loader-dark.gif": 29382,
	"./images/idrive-loader.gif": 57721,
	"./images/idrive-loader_dark-theme.gif": 46128,
	"./images/laptop-icon.svg": 20733,
	"./images/microsoft-disabled.png": 33342,
	"./images/microsoft.png": 2451,
	"./images/welcome-screen-dropbox-box.png": 95587,
	"./images/welcome-screen-microsoft.png": 2893,
	"./images/welcome-screen.png": 46930,
	"./microsoft_logo.svg": 54626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54862;